/** Share of newly completed responses that ask the user for feedback. */
export const FEEDBACK_REMINDER_CHANCE = 0.1;

/** Overrides the chance for testing: a number from 0 to 1, so "1" asks on every response. */
export const FEEDBACK_REMINDER_CHANCE_STORAGE_KEY = 'fletch:feedback-reminder-chance';

const readFeedbackReminderChance = (): number => {
  try {
    const raw = localStorage.getItem(FEEDBACK_REMINDER_CHANCE_STORAGE_KEY)?.trim();
    const chance = raw ? Number(raw) : Number.NaN;
    return chance >= 0 && chance <= 1 ? chance : FEEDBACK_REMINDER_CHANCE;
  } catch {
    return FEEDBACK_REMINDER_CHANCE;
  }
};

/** Rolled once per response, when its run first finishes. */
export const shouldAskForFeedback = () => Math.random() < readFeedbackReminderChance();
